import React from "react"
import PropTypes from "prop-types"

const ApplicantThumb = ({ jobApplication, onClick, active, label, clickable = true }) => {
    const src = jobApplication.attributes.transcoded_video_preview_url;
    const name = jobApplication.attributes.applicant.name;
    const className = `applicant-thumb${active ? ' is-active' : ''}`;
    const inner = (
        <>
            {src ? (
                <img src={src} alt="" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
            ) : (
                <span className="applicant-thumb__ph" aria-hidden="true" />
            )}
            <span className="applicant-thumb__play" aria-hidden="true" />
        </>
    );

    if (!clickable) {
        return <span className={className}>{inner}</span>;
    }

    return (
        <button
            type="button"
            className={className}
            onClick={onClick}
            aria-label={label || `Play ${name}'s video`}
        >
            {inner}
        </button>
    );
};

ApplicantThumb.propTypes = {
    jobApplication: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    active: PropTypes.bool,
    label: PropTypes.string,
    clickable: PropTypes.bool,
};

export default ApplicantThumb;
